import React, { useState, useEffect } from "react";
import { CustomCard, CustomCardContent, CustomCardHeaderWithPopover,Divider } from './CustomComponents';
import Plot from 'react-plotly.js';
import { useGraphContext } from '../GraphContext';
import Spinner from "./Spinner";
import shift from '../assets/overnight.png';

const Shift_Mileage = ({ submitClicked, handleDownload, error }) => {
  const [histogramData_mileage, setHistogramData_mileage] = useState(null);
  const [boxPlotData_mileage, setBoxPlotData_mileage] = useState(null);

  const [histogramData_duration, setHistogramData_duration] = useState(null);
  const [boxPlotData_duration, setBoxPlotData_duration] = useState(null);

  const [histogramData_speed, setHistogramData_speed] = useState(null);
  const [boxPlotData_speed, setBoxPlotData_speed] = useState(null);
  
  const [histogramData_count, setHistogramData_count] = useState(null);
  const [boxPlotData_count, setBoxPlotData_count] = useState(null);

  const [histogramData_breaktime, setHistogramData_breaktime] = useState(null);
  const [boxPlotData_breaktime, setBoxPlotData_breaktime] = useState(null);

  const [loading, setLoading] = useState(true); // Loading state

  // Define a style object for bold text
  const boldStyle = {
    fontWeight: 'bold'
  };

  const { filters } = useGraphContext();
  useEffect(() => {
      if (filters) {
        setLoading(true); // Set loading to true when filters change
          try {
              const parsedFilters = JSON.parse(filters.shift_overnight);
              const overnight_shift=JSON.parse(filters.overnight_shift_duration);
              const overnight_shift_count=JSON.parse(filters.overnight_shift_count);
              const overnight_avg_speed_bin=JSON.parse(filters.overnight_avg_speed_bin);
              const overnight_breaktime_before_shift=JSON.parse(filters.overnight_breaktime_before_shift);

              const shift_mileage__km_p90_8h=filters.box.shift_mileage__km_p90_8h;
              const shift_duration__hour_p90_8h=filters.box.shift_duration__hour_p90_8h;
              const cnt_of_shifts_year_8h=filters.box.cnt_of_shifts_year_8h;
              const overnight_avg_speed_bin_box=filters.box.avg_speed_year_8h;
              const breaktime_before_shift__hour_p10_8h=filters.box.breaktime_before_shift__hour_p10_8h;

              setHistogramData_mileage(parsedFilters);
              setHistogramData_duration(overnight_shift);
              setHistogramData_count(overnight_shift_count);
              setHistogramData_speed(overnight_avg_speed_bin);
              setHistogramData_breaktime(overnight_breaktime_before_shift);
              
              setBoxPlotData_mileage(shift_mileage__km_p90_8h);
              setBoxPlotData_duration(shift_duration__hour_p90_8h);
              setBoxPlotData_count(cnt_of_shifts_year_8h);
              setBoxPlotData_speed(overnight_avg_speed_bin_box);
              setBoxPlotData_breaktime(breaktime_before_shift__hour_p10_8h);

          } catch (error) {
              console.error('Error parsing JSON:', error);
          } finally {
            setLoading(false); // Set loading to false after data processing
        }
      }
      else{
        setLoading(false); // Set loading to false after data processing 
    }
  }, [filters]);

  return (
    <div className="KPI_main_div" >

    <div>
        <div className="outer_div_title_onTop_of_KPI" >
            <h6 className="title_onTop_of_KPI" >Definition </h6>
        </div>
        <div style={{ display: 'flex', backgroundColor: 'white',alignItems: 'center', padding: '10px'}}>
            <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <img src={shift} style={{ width: '100%', margin: 0, padding: 0}}/>
            </div>
            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', textAlign: 'left' }}>
  <ul style={{ fontFamily: 'MAN EUROPE_regular', fontSize: '16px', color: 'rgb(48, 60, 73)' }}>
    <li>A shift is a vehicle operation between two breaks of a defined period of time.</li>
    <li>
      On this page we investigate shifts <span style={{ fontWeight: 'bold' }}>between a break time of at least 8 hours.</span>
    </li>
    <li>Generally speaking this represents a workday (in single driver operation).</li>
    <li>
      Shifts between break time of at least 8 hours are a <b></b>subset of 
      <span style={{ fontStyle: 'italic' }}> “shifts between break time of at least 30 minutes”.</span>
    </li>
  </ul>
</div>

        </div>
    </div>
    
    <div style={{ marginTop: '20px'}}>
        <div className="outer_div_title_onTop_of_KPI" >
            <h6 className="title_onTop_of_KPI" >Shift mileage (90th percentile)</h6>
        </div>

        <div className="plot_div" >
            <div style={{ flex: 1 }}>
            <CustomCard>
                <CustomCardHeaderWithPopover title='Histogram' id= 'Shift_Mileage_histo'
                    content= {
                `<ul>
                <li>This histogram visualizes the distribution of numerical data using bins of 50 km each. Each bar represents the absolute count of VINs (vehicles) falling within a specific mileage range, based on your selection on the "Filter" page.</li>
                
                <li><b>Metric:</b> This chart displays the 90th percentile of shift mileage per vehicle and year. The 90th percentile represents a value of mileage where 90 percent of all shifts per vehicle and year are smaller than this value, meaning only 10 percent of shifts for that vehicle and year had higher mileage. This helps focus on typical high-usage behavior while minimizing the impact of outliers.</li>
                
                <li><b>Counting logic:</b> If a vehicle operates in multiple years, it is counted once per year and may appear in the same or different bins.<br />
                <i>Example:</i> A vehicle sold in 2024 will appear twice—once for 2024 and once for 2025—since it has two years of operation.<br />
                As a result, the total count in the histogram may exceed the number of "activated vehicles."</li>
                
                <li><b>Overlay line chart:</b> A cumulative line graph is layered over the bars to show the relative cumulative distribution of vehicles across mileage bins.</li>
                </ul>`

                    } 
                    handleDownload={handleDownload}
                    downloadOption="shift_mileage_histo"
                />
                <Divider className="divider" />
                <CustomCardContent>
                    {submitClicked ? (
                        loading ? (
                            <Spinner />
                                ) : error ? (
                                    <div className="error_message">
                                        <p>Invalid combination - please check your inputs.</p>
                                    </div>
                                    ) : histogramData_mileage ? (
                                    <Plot
                                        data={histogramData_mileage.data}
                                        layout={histogramData_mileage.layout}
                                        config={{ responsive: true }}
                                        style={{ width: '100%', height: '100%' }}
                                        useResizeHandler={true}
                                        autosize={true}
                                    />
                                ) : null
                            ) : (
                                <div className="no_vehicles_message" >
                                    <p>No vehicle(s) selected - please apply filter</p>
                                </div>
                    )}
                </CustomCardContent>
            </CustomCard>
            </div>
            <div style={{ flex: 1 }}>
            <CustomCard>
                <CustomCardHeaderWithPopover title='Boxplot' id= 'Shift_Mileage_box'
                    content= {
                    `<ul>
                    <li>A boxplot is a visual tool used to show how numerical data is distributed.</li>
                    
                    <li><b>Metric:</b> This chart focusses on the 90th percentile of shift mileage per vehicle and year. The 90th percentile represents a value of mileage where 90 percent of all shifts per vehicle and year are smaller than this value. Meaning that only 10 percent of shifts for that vehicle and year had higher mileage. This highlights typical high-usage behavior while minimizing the impact of outliers.</li>
                    
                    <li><b>Counting logic:</b> If a vehicle operates in multiple years, it is present in the respective year bar.</li>
                    
                    <li><b>Visualization:</b> The boxplot shows the distribution of 90th percentile of shift mileage using five key values:
                        <ul>
                        <li><b>5th percentile (Min)</b> – the lower extreme of the data</li>
                        <li><b>25th percentile (Q1)</b> – the lower quartile</li>
                        <li><b>50th percentile (Median)</b> – the middle value</li>
                        <li><b>75th percentile (Q3)</b> – the upper quartile</li>
                        <li><b>95th percentile (Max)</b> – the upper extreme of the data</li>
                        </ul>
                    </li>
                    
                    <li>Boxplots are especially useful for comparing distribution patterns across different years, helping to highlight shifts, trends, or anomalies in vehicle usage over time.</li>
                    </ul>`

                    } 
                    handleDownload={handleDownload}
                    downloadOption="shift_mileage__km_p90_8h"
                />
                <Divider className="divider" />
                <CustomCardContent>
                    {submitClicked ? (
                        loading ? (
                            <Spinner />
                                ) : error ? (
                                    <div className="error_message">
                                        <p>Invalid combination - please check your inputs.</p>
                                    </div>
                                    ) : boxPlotData_mileage ? (
                                    <Plot
                                        data={boxPlotData_mileage.data}
                                        layout={boxPlotData_mileage.layout}
                                        config={{ responsive: true }}
                                        style={{ width: '100%', height: '100%' }}
                                        useResizeHandler={true}
                                        autosize={true}
                                        />
                                    ) : null
                                ) : (
                                    <div className="no_vehicles_message" >
                                        <p>No vehicle(s) selected - please apply filter</p>
                                    </div>
                    )}
                </CustomCardContent>
            </CustomCard>
            </div>
        </div>
    </div>

    <div style={{ marginTop: '20px'}}>
      <div className="outer_div_title_onTop_of_KPI" >
        <h6 className="title_onTop_of_KPI" >Shift duration (90th percentile)</h6>
      </div>

        <div className="plot_div" >
            <div style={{ flex: 1 }}>
            <CustomCard>
                <CustomCardHeaderWithPopover title='Histogram' id= 'Shift_duration_histo'
                    content= {
           ` <ul>
            <li>This histogram visualizes the distribution of numerical data using bins of 1 h each. Each bar represents the absolute count of VINs (vehicles) falling within a specific duration range, based on your selection on the "Filter" page.</li>
            
            <li><b>Metric:</b> This chart displays the 90th percentile of shift duration per vehicle and year. The 90th percentile represents a value of duration where 90 percent of all shifts per vehicle and year are smaller than this value, meaning only 10 percent of shifts for that vehicle and year had higher duration. This helps focus on typical high-usage behavior while minimizing the impact of outliers.</li>
            
            <li><b>Counting logic:</b> If a vehicle operates in multiple years, it is counted once per year and may appear in the same or different bins.<br />
            <i>Example:</i> A vehicle sold in 2024 will appear twice—once for 2024 and once for 2025—since it has two years of operation.<br />
            As a result, the total count in the histogram may exceed the number of "activated vehicles."</li>
            
            <li><b>Overlay line chart:</b> A cumulative line graph is layered over the bars to show the relative cumulative distribution of vehicles across duration bins.</li>
            </ul>`

                    }
                    handleDownload={handleDownload}
                    downloadOption="shift_duration_histo_overnight" 
                />
                <Divider className="divider" />
                <CustomCardContent>
                    {submitClicked ? (
                        loading ? (
                            <Spinner />
                                ) : error ? (
                                    <div className="error_message">
                                        <p>Invalid combination - please check your inputs.</p>
                                    </div>
                                    ) : histogramData_duration ? (
                                    <Plot
                                        data={histogramData_duration.data}
                                        layout={histogramData_duration.layout}
                                        config={{ responsive: true }}
                                        style={{ width: '100%', height: '100%' }}
                                        useResizeHandler={true}
                                        autosize={true}
                                    />
                                ) : null
                            ) : (
                                <div className="no_vehicles_message" >
                                    <p>No vehicle(s) selected - please apply filter</p>
                                </div>
                    )}
                </CustomCardContent>
            </CustomCard>
            </div>
            <div style={{ flex: 1 }}>
            <CustomCard>
                <CustomCardHeaderWithPopover title='Boxplot' id= 'Shift_duration_box'
                    content= {
                    `<ul>
                    <li>A boxplot is a visual tool used to show how numerical data is distributed.</li>
                    
                    <li><b>Metric:</b> This chart focusses on the 90th percentile of shift duration per vehicle and year. The 90th percentile represents a value of duration where 90 percent of all shifts per vehicle and year are smaller than this value. Meaning that only 10 percent of shifts for that vehicle and year had higher duration. This highlights typical high-usage behavior while minimizing the impact of outliers.</li>
                    
                    <li><b>Counting logic:</b> If a vehicle operates in multiple years, it is present in the respective year bar.</li>
                    
                    <li><b>Visualization:</b> The boxplot shows the distribution of 90th percentile of shift duration using five key values:
                        <ul>
                        <li><b>5th percentile (Min)</b> – the lower extreme of the data</li>
                        <li><b>25th percentile (Q1)</b> – the lower quartile</li>
                        <li><b>50th percentile (Median)</b> – the middle value</li>
                        <li><b>75th percentile (Q3)</b> – the upper quartile</li>
                        <li><b>95th percentile (Max)</b> – the upper extreme of the data</li>
                        </ul>
                    </li>
                    
                    <li>Boxplots are especially useful for comparing distribution patterns across different years, helping to highlight shifts, trends, or anomalies in vehicle usage over time.</li>
                    </ul>`

                    } 
                    handleDownload={handleDownload}
                    downloadOption="shift_duration__hour_p90_8h"
                />
                <Divider className="divider" />
                <CustomCardContent>
                    {submitClicked ? (
                        loading ? (
                            <Spinner />
                                ) : error ? (
                                    <div className="error_message">
                                        <p>Invalid combination - please check your inputs.</p>
                                    </div>
                                    ) : boxPlotData_duration ? (
                                    <Plot
                                        data={boxPlotData_duration.data}
                                        layout={boxPlotData_duration.layout}
                                        config={{ responsive: true }}
                                        style={{ width: '100%', height: '100%' }}
                                        useResizeHandler={true}
                                        autosize={true}
                                        />
                                    ) : null
                                ) : (
                                    <div className="no_vehicles_message" >
                                        <p>No vehicle(s) selected - please apply filter</p>
                                    </div>
                    )}
                </CustomCardContent>
            </CustomCard>
            </div>
        </div>
    </div>

    <div style={{ marginTop: '20px'}}>
      <div className="outer_div_title_onTop_of_KPI" >
        <h6 className="title_onTop_of_KPI" >Shift average speed</h6>
      </div>

        <div className="plot_div" >
            <div style={{ flex: 1 }}>
            <CustomCard>
                <CustomCardHeaderWithPopover title='Histogram' id= 'overnight_speed_histo'
                    content= {
                `
                <ul>
                  <li>This histogram visualizes the distribution of numerical data using bins of 10 km/h each. Each bar represents the absolute count of VINs (vehicles) falling within a specific speed range, based on your selection on the "Filter" page.</li>

                  <li><strong>Metric:</strong> This chart displays the shift average speed per vehicle and year.</li>
                  <li><strong>Counting logic:</strong> If a vehicle operates in multiple years, it is counted once per year and may appear in the same or different bins.</li>
                  <li><strong>Example:</strong> A vehicle sold in 2024 will appear twice—once for 2024 and once for 2025—since it has two years of operation.</li>
                  <li>As a result, the total count in the histogram may exceed the number of "activated vehicles."</li>

                  <li><strong>Overlay line chart:</strong> A cumulative line graph is layered over the bars to show the relative cumulative distribution of vehicles across speed bins.</li>
                </ul>
                `


                    } 
                    handleDownload={handleDownload}
                    downloadOption="overnight_avg_speed_bin"
                />
                <Divider className="divider" />
                <CustomCardContent>
                    {submitClicked ? (
                        loading ? (
                            <Spinner />
                                ) : error ? (
                                    <div className="error_message">
                                        <p>Invalid combination - please check your inputs.</p>
                                    </div>
                                    ) : histogramData_speed ? (
                                    <Plot
                                        data={histogramData_speed.data}
                                        layout={histogramData_speed.layout}
                                        config={{ responsive: true }}
                                        style={{ width: '100%', height: '100%' }}
                                        useResizeHandler={true}
                                        autosize={true}
                                    />
                                ) : null
                            ) : (
                                <div className="no_vehicles_message" >
                                    <p>No vehicle(s) selected - please apply filter</p>
                                </div>
                    )}
                </CustomCardContent>
            </CustomCard>
            </div>
            <div style={{ flex: 1 }}>
            <CustomCard>
                <CustomCardHeaderWithPopover title='Boxplot' id= 'overnight_speed_box'
                    content= {
                    `<ul>
                    <li>A boxplot is a visual tool used to show how numerical data is distributed.</li>
                    
                    <li><b>Metric:</b> This chart focusses on the shift average speed per vehicle and year.</li>
                    
                    <li><b>Counting logic:</b> If a vehicle operates in multiple years, it is present in the respective year bar.</li>
                    
                    <li><b>Visualization:</b> The boxplot shows the distribution of average shift mileage using five key values:
                        <ul>
                        <li><b>5th percentile (Min)</b> – the lower extreme of the data</li>
                        <li><b>25th percentile (Q1)</b> – the lower quartile</li>
                        <li><b>50th percentile (Median)</b> – the middle value</li>
                        <li><b>75th percentile (Q3)</b> – the upper quartile</li>
                        <li><b>95th percentile (Max)</b> – the upper extreme of the data</li>
                        </ul>
                    </li>
                    
                    <li>Boxplots are especially useful for comparing distribution patterns across different years, helping to highlight shifts, trends, or anomalies in vehicle usage over time.</li>
                    </ul>`
                    }
                    handleDownload={handleDownload}
                    downloadOption="avg_speed_year_8h" 
                />
                <Divider className="divider" />
                <CustomCardContent>
                    {submitClicked ? (
                        loading ? (
                            <Spinner />
                                ) : error ? (
                                    <div className="error_message">
                                        <p>Invalid combination - please check your inputs.</p>
                                    </div>
                                    ) : boxPlotData_speed ? (
                                    <Plot
                                        data={boxPlotData_speed.data}
                                        layout={boxPlotData_speed.layout}
                                        config={{ responsive: true }}
                                        style={{ width: '100%', height: '100%' }}
                                        useResizeHandler={true}
                                        autosize={true}
                                        />
                                    ) : null
                                ) : (
                                    <div className="no_vehicles_message" >
                                        <p>No vehicle(s) selected - please apply filter</p>
                                    </div>
                        )}
                </CustomCardContent>
            </CustomCard>
            </div>
        </div>
    </div>

    <div style={{ marginTop: '20px'}}>
      <div className="outer_div_title_onTop_of_KPI" >
        <h6 className="title_onTop_of_KPI" >Count of shifts</h6>
      </div>

        <div className="plot_div" >
            <div style={{ flex: 1 }}>
            <CustomCard>
                <CustomCardHeaderWithPopover title='Histogram' id= 'Shift_count_histo'
                    content= {
                    `
                    <ul>
                      <li>This histogram visualizes the distribution of numerical data using bins of 50 each. Each bar represents the absolute count of VINs (vehicles) falling within a specific count range, based on your selection on the "Filter" page.</li>

                      <li><strong>Metric:</strong> This chart displays the absolute count of shifts per vehicle and year.</li>
                      <li><strong>Counting logic:</strong> If a vehicle operates in multiple years, it is counted once per year and may appear in the same or different bins.</li>
                      <li><strong>Example:</strong> A vehicle sold in 2024 will appear twice—once for 2024 and once for 2025—since it has two years of operation.</li>
                      <li>As a result, the total count in the histogram may exceed the number of "activated vehicles."</li>

                      <li><strong>Overlay line chart:</strong> A cumulative line graph is layered over the bars to show the relative cumulative distribution of vehicles across count bins.</li>
                    </ul>
                    `

                    }
                    // handleDownload={handleDownload}
                    // downloadOption="overnight_shift_count" 
                />
                <Divider className="divider" />
                <CustomCardContent>
                    {submitClicked ? (
                        loading ? (
                            <Spinner />
                                ) : error ? (
                                    <div className="error_message">
                                        <p>Invalid combination - please check your inputs.</p>
                                    </div>
                                    ) : histogramData_count ? (
                                    <Plot
                                        data={histogramData_count.data}
                                        layout={histogramData_count.layout}
                                        config={{ responsive: true }}
                                        style={{ width: '100%', height: '100%' }}
                                        useResizeHandler={true}
                                        autosize={true}
                                    />
                                ) : null
                            ) : (
                                <div className="no_vehicles_message" >
                                    <p>No vehicle(s) selected - please apply filter</p>
                                </div>
                    )}
                </CustomCardContent>
            </CustomCard>
            </div>
            <div style={{ flex: 1 }}>
            <CustomCard>
                <CustomCardHeaderWithPopover title='Boxplot' id= 'Shift_count_box'
                    content= {
                `<ul>
                <li>A boxplot is a graphical representation of how numerical data is distributed. It summarizes the data through percentiles rather than showing every value.</li>
                <li><b>Metric:</b> This chart focuses on the absolute count of shifts per vehicle and year.</li>
                <li><b>Counting logic:</b> If a vehicle operates in multiple years, it is included once in each respective year bar.</li>
                <li>The boxplot displays the distribution of shift counts using five key values:
                    <ul>
                    <li><b>5th percentile (Min)</b> – the lower extreme of the data</li>
                    <li><b>25th percentile (Q1)</b> – the lower quartile</li>
                    <li><b>50th percentile (Median)</b> – the middle value</li>
                    <li><b>75th percentile (Q3)</b> – the upper quartile</li>
                    <li><b>95th percentile (Max)</b> – the upper extreme of the data</li>
                    </ul>
                </li>
                <li>Boxplots are especially useful for comparing distribution patterns across different years, helping to identify shifts, trends, or anomalies in vehicle usage over time.</li>
                </ul>`

                    } 
                    handleDownload={handleDownload}
                    downloadOption="cnt_of_shifts_year_8h"
                />
                <Divider className="divider" />
                <CustomCardContent>
                    {submitClicked ? (
                        loading ? (
                            <Spinner />
                                ) : error ? (
                                    <div className="error_message">
                                        <p>Invalid combination - please check your inputs.</p>
                                    </div>
                                    ) : boxPlotData_count ? (
                                    <Plot
                                        data={boxPlotData_count.data}
                                        layout={boxPlotData_count.layout}
                                        config={{ responsive: true }}
                                        style={{ width: '100%', height: '100%' }}
                                        useResizeHandler={true}
                                        autosize={true}
                                        />
                                    ) : null
                                ) : (
                                    <div className="no_vehicles_message" >
                                        <p>No vehicle(s) selected - please apply filter</p>
                                    </div>
                    )}
                </CustomCardContent>
            </CustomCard>
            </div>
        </div>
    </div>

    <div style={{ marginTop: '20px'}}>
        <div className="outer_div_title_onTop_of_KPI" >
            <h6 className="title_onTop_of_KPI" >Break time before shift start (10th percentile)</h6>
        </div>

        <div className="plot_div" >
            <div style={{ flex: 1 }}>
            <CustomCard>
                <CustomCardHeaderWithPopover title='Histogram' id= 'overnight_breaktime_histo'
                    content= {
                `
                <ul>
                  <li>This histogram visualizes the distribution of numerical data using bins of 0,5 h each. Each bar represents the absolute count of VINs (vehicles) falling within a specific break time range, based on your selection on the "Filter" page.</li>

                  <li><strong>Metric:</strong> This chart displays the 10th percentile of shift break time per vehicle and year. The 10th percentile represents a value of break time where 10 percent of all breaks per vehicle and year are shorter than this value. Meaning that 90 percent of the breaks for that vehicle and year were longer. This helps focus on typical high-usage behavior while minimizing the impact of outliers.</li>
                  <li><strong>Counting logic:</strong> If a vehicle operates in multiple years, it is counted once per year and may appear in the same or different bins.</li>
                  <li><strong>Example:</strong> A vehicle sold in 2024 will appear twice—once for 2024 and once for 2025—since it has two years of operation.</li>
                  <li>As a result, the total count in the histogram may exceed the number of "activated vehicles."</li>

                  <li><strong>Overlay line chart:</strong> A cumulative line graph is layered over the bars to show the relative cumulative distribution of vehicles across mileage bins.</li>
                </ul>
                `

                    }
                    // handleDownload={handleDownload}
                    // downloadOption="overnight_breaktime_before_shift"
                />
                <Divider className="divider" />
                <CustomCardContent>
                    {submitClicked ? (
                        loading ? (
                            <Spinner />
                                ) : error ? (
                                    <div className="error_message">
                                        <p>Invalid combination - please check your inputs.</p>
                                    </div>
                                    ) : histogramData_breaktime ? (
                                    <Plot
                                        data={histogramData_breaktime.data}
                                        layout={histogramData_breaktime.layout}
                                        config={{ responsive: true }}
                                        style={{ width: '100%', height: '100%' }}
                                        useResizeHandler={true}
                                        autosize={true}
                                    />
                                ) : null
                            ) : (
                                <div className="no_vehicles_message" >
                                    <p>No vehicle(s) selected - please apply filter</p>
                                </div>
                    )}
                </CustomCardContent>
            </CustomCard>
            </div>
            <div style={{ flex: 1 }}>
            <CustomCard>
                <CustomCardHeaderWithPopover title='Boxplot' id= 'overnight_breaktime_box'
                    content= {
                `<ul>
                <li>A boxplot is a visual tool used to show how numerical data is distributed.</li>
                
                <li><b>Metric:</b> This chart focuses on the 10th percentile of shift break time per vehicle and year. The 10th percentile represents a value of break time where 10% of all breaks per vehicle and year are shorter than this value, meaning 90% of the breaks were longer. This helps highlight typical usage while minimizing the impact of outliers.</li>
                
                <li><b>Counting logic:</b> If a vehicle operates in multiple years, it is present in the respective year bar.</li>
                
                <li><b>Visualization:</b> The boxplot shows the distribution of the 10th percentile of shift break time using five key values:
                    <ul>
                    <li>5th percentile (Min) – the lower extreme of the data</li>
                    <li>25th percentile (Q1) – the lower quartile</li>
                    <li>50th percentile (Median) – the middle value</li>
                    <li>75th percentile (Q3) – the upper quartile</li>
                    <li>95th percentile (Max) – the upper extreme of the data</li>
                    </ul>
                </li>
                
                <li>Boxplots are useful for comparing distribution patterns across different years, helping to highlight shifts, trends, or anomalies in vehicle usage over time.</li>
                </ul>`

                    }
                    handleDownload={handleDownload}
                    downloadOption="breaktime_before_shift__hour_p10_8h" 
                />
                <Divider className="divider" />
                <CustomCardContent>
                    {submitClicked ? (
                        loading ? (
                            <Spinner />
                                ) : error ? (
                                    <div className="error_message">
                                        <p>Invalid combination - please check your inputs.</p>
                                    </div>
                                    ) : boxPlotData_breaktime ? (
                                    <Plot
                                        data={boxPlotData_breaktime.data}
                                        layout={boxPlotData_breaktime.layout}
                                        config={{ responsive: true }}
                                        style={{ width: '100%', height: '100%' }}
                                        useResizeHandler={true}
                                        autosize={true}
                                        />
                                    ) : null
                                ) : (
                                    <div className="no_vehicles_message" >
                                        <p>No vehicle(s) selected - please apply filter</p>
                                    </div>
                    )}
                </CustomCardContent>
            </CustomCard>
            </div>
        </div>
    </div>
    </div>
  );
};

export default Shift_Mileage;
